import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { alertsApi } from '../api/alerts.api';

const keys = {
  live:       (depId)              => ['deployment', depId, 'alerts', 'live'],
  historical: (depId, params)      => ['deployment', depId, 'alerts', 'historical', params],
  detail:     (depId, alertId)     => ['deployment', depId, 'alerts', 'detail', alertId],
  filters:    (depId)              => ['deployment', depId, 'alerts', 'filters'],
};

export function useAlertsLive(depId) {
  return useQuery({
    queryKey: keys.live(depId),
    queryFn:  () => alertsApi.live(depId),
    enabled:  !!depId,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

// Paginated history. `data` is { rows, pagination }. keepPreviousData keeps the
// current page visible while the next page loads (no empty flash on page change).
export function useAlertsHistorical(depId, params = {}) {
  return useQuery({
    queryKey: keys.historical(depId, params),
    queryFn:  () => alertsApi.historical(depId, params),
    enabled:  !!depId,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}

export function useAlertDetail(depId, alertId) {
  return useQuery({
    queryKey: keys.detail(depId, alertId),
    queryFn:  () => alertsApi.detail(depId, alertId),
    enabled:  !!depId && !!alertId,
    staleTime: 30_000,
  });
}

export function useAlertsFilterSchema(depId) {
  return useQuery({
    queryKey: keys.filters(depId),
    queryFn:  () => alertsApi.filters(depId),
    enabled:  !!depId,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}


